module.exports = __webpack_public_path__ + "img/money.fc64325e.svg";